export default "__VITE_ASSET__DBr_$_$E__"